import { DropdownMenuItem } from '@/components/ui/DropdownMenu'
import {
  DocumentMagnifyingGlassIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import React, { useState } from 'react'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Separator } from '@radix-ui/react-separator'
import { Button } from '@/components/ui/button'
import MoneyPathsTable from './MoneyPathsTable'
import { Link, useNavigate } from 'react-router-dom'

export default function MoneyPathsModal({ open, setOpen }) {
  const navigate = useNavigate()

  return (
    <>
      <Dialog open={true} onOpenChange={() => navigate('/')} defaultOpen={true}>
        <DialogContent className="max-h-[37.5rem] min-h-[15rem] md:max-w-2xl ">
          <DialogHeader>
            <DialogTitle>Money Paths</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>

          <Separator />
          <DialogBody className="flex flex-col gap-4">
            <MoneyPathsTable />
          </DialogBody>
          <Separator />
          <DialogFooter>
            <Link to="/money-paths/new">
              <Button type="button">Create New</Button>
            </Link>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/')}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
